import useSyncStore from '@/store/SyncStore'

/**
 * Returns true when the REST API has been detected as unreachable.
 * Callers should use this to disable REST-only actions and render offline
 * fallbacks. RxDB-backed screens keep working and should NOT gate on this.
 */
export const useIsApiDown = (): boolean =>
  useSyncStore((s) => s.apiStatus === 'down')
